/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveConnection_Mutation = { readonly __typename: 'Mutation', readonly removeConnection: boolean };


export type RemoveConnectionVariables = _Types.Exact<{
  externalConnectionGuid: _Types.Scalars['String']['input'];
}>;


export type RemoveConnection = RemoveConnection_Mutation;


export const RemoveConnectionDocument = gql`
    mutation RemoveConnection($externalConnectionGuid: String!) {
  removeConnection(externalConnectionGuid: $externalConnectionGuid)
}
    `;
export type RemoveConnectionMutationFn = Apollo.MutationFunction<RemoveConnection, RemoveConnectionVariables>;

/**
 * __useRemoveConnection__
 *
 * To run a mutation, you first call `useRemoveConnection` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConnection` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConnection, { data, loading, error }] = useRemoveConnection({
 *   variables: {
 *      externalConnectionGuid: // value for 'externalConnectionGuid'
 *   },
 * });
 */
export function useRemoveConnection(baseOptions?: Apollo.MutationHookOptions<RemoveConnection, RemoveConnectionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveConnection, RemoveConnectionVariables>(RemoveConnectionDocument, options);
      }
export type RemoveConnectionHookResult = ReturnType<typeof useRemoveConnection>;
export type RemoveConnectionMutationResult = Apollo.MutationResult<RemoveConnection>;
export type RemoveConnectionMutationOptions = Apollo.BaseMutationOptions<RemoveConnection, RemoveConnectionVariables>;